// extracted by mini-css-extract-plugin
export default {"searchSuggestion":"customCSS_searchSuggestion__6MQOF","searchDiv":"customCSS_searchDiv__Ks+nI"};